const getQueryStringFromUrl = (url) => {
  const index = url.indexOf('?')
  if (index < 0) return ''

  const paramsString = url.substr(index + 1)

  return `?${paramsString}`
}
export default getQueryStringFromUrl
